// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/pattern_editor/templates/patterneditor.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "hscroll"
      },
    marko_attrs1 = {
        "class": "pattern"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("8f56ad"),
    marko_node0 = marko_createElement("div", {
        "class": "timeline"
      }, "2", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("canvas", {
          "class": "timelinecanvas"
        }, null, null, 0),
    marko_attrs2 = {
        "class": "patterndata"
      },
    marko_attrs3 = {
        "class": "track-headers"
      },
    marko_attrs4 = {
        "class": "track-names"
      },
    marko_attrs5 = {
        "class": "track-controls"
      },
    marko_node1 = marko_createElement("canvas", {
        id: "gfxpattern"
      }, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("div", {
        "class": "timeline"
      }, "20", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("canvas", {
          "class": "timelinecanvas"
        }, null, null, 0),
    marko_attrs6 = {
        "class": "controls"
      },
    marko_attrs7 = {
        "class": "panel"
      },
    marko_attrs8 = {
        "class": "control-group horizontal-buttons"
      },
    marko_attrs9 = {
        "class": "add-column"
      },
    marko_attrs10 = {
        "class": "remove-column"
      },
    marko_attrs11 = {
        "class": "fas fa-plus-square"
      },
    marko_attrs12 = {
        "class": "fas fa-minus-square"
      },
    marko_attrs13 = {
        "class": "control-panel"
      },
    marko_attrs14 = {
        "class": "control-group"
      },
    marko_attrs15 = {
        "class": "control-group"
      },
    marko_node3 = marko_createElement("div", {
        "class": "control-group horizontal-buttons"
      }, "32", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "add-track"
        }, null, null, 1)
        .e("i", {
            "class": "fas fa-plus-square"
          }, null, null, 0)
      .e("button", {
          id: "remove-track"
        }, null, null, 1)
        .e("i", {
            "class": "fas fa-minus-square"
          }, null, null, 0),
    marko_attrs16 = {
        "class": "control range"
      },
    marko_node4 = marko_createElement("label", {
        "for": "step"
      }, "26", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Step"),
    marko_attrs17 = {
        "class": "control range"
      },
    marko_node5 = marko_createElement("label", {
        "for": "size"
      }, "30", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Length");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.n(marko_node0, component);

  out.be("div", marko_attrs2, "4", component);

  out.be("div", marko_attrs3, "5", component);

  out.be("div", marko_attrs4, "6", component);

  var $for$0 = 0;

  marko_forOf(data.tracknames, function(i, loopIndex, loopAll) {
    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.e("div", {
        "class": "track-name",
        "data-trackindex": loopIndex
      }, "7" + $keyScope$0, component, 1)
      .e("div", null, "8" + $keyScope$0, component, 1)
        .t(i, component);
  });

  out.ee();

  out.t(" ");

  out.be("div", marko_attrs5, "9", component);

  var $for$1 = 0;

  marko_forOf(data.tracknames, function(i, loopIndex, loopAll) {
    var $keyScope$1 = "[" + (($for$1++) + "]");

    out.e("div", {
        "class": "track-control",
        "data-trackindex": loopIndex
      }, "10" + $keyScope$1, component, 1)
      .e("div", marko_attrs7, "11" + $keyScope$1, component, 1)
        .e("div", marko_attrs8, "12" + $keyScope$1, component, 2)
          .e("button", marko_attrs9, "13" + $keyScope$1, component, 1)
            .e("div", null, "14" + $keyScope$1, component, 1)
              .e("i", marko_attrs11, "15" + $keyScope$1, component, 0)
          .e("button", marko_attrs10, "16" + $keyScope$1, component, 1)
            .e("div", null, "17" + $keyScope$1, component, 1)
              .e("i", marko_attrs12, "18" + $keyScope$1, component, 0);
  });

  out.ee();

  out.t(" ");

  out.ee();

  out.n(marko_node1, component);

  out.ee();

  out.n(marko_node2, component);

  out.ee();

  out.ee();

  out.e("div", marko_attrs6, "22", component, 1)
    .e("div", marko_attrs13, "23", component, 3)
      .e("div", marko_attrs14, "24", component, 1)
        .e("div", marko_attrs16, "25", component, 2)
          .n(marko_node4, component)
          .e("input", {
              id: "step",
              "class": "range-input",
              value: data.transport.step,
              type: "text"
            }, "27", component, 0)
      .e("div", marko_attrs15, "28", component, 1)
        .e("div", marko_attrs17, "29", component, 2)
          .n(marko_node5, component)
          .e("input", {
              id: "length",
              "class": "range-input",
              value: data.numrows,
              type: "text"
            }, "31", component, 0)
      .n(marko_node3, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
